import React from 'react';
import { useIntl } from 'react-intl';
import { useFragment, graphql, useMutation } from 'react-relay/hooks';
import { Flexbox, Switch } from '@sonika-se/ui-kit/components';
export const EditEventIsAssigneeReplacementReason = (props) => {
    const { eventRef } = props;
    const intl = useIntl();
    const { id, isAssigneeReplacementReason } = useFragment(graphql `
      fragment EditEventIsAssigneeReplacementReason_event on Event {
        id
        isAssigneeReplacementReason
      }
    `, eventRef);
    const [updateEvent, updateEventLoading] = useMutation(graphql `
    mutation EditEventIsAssigneeReplacementReasonMutation($model: UpdateEventRequestInput!) {
      updateEvent(model: $model) {
        eventEdge {
          node {
            id
            isAssigneeReplacementReason
          }
        }
      }
    }
  `);
    return (<Flexbox align="center">
      <Switch disabled={updateEventLoading} checked={isAssigneeReplacementReason} label={intl.formatMessage({
            id: 'EventSettings.isAssigneeReplacementReason',
            defaultMessage: 'Är bytesanledning',
        })} onChange={() => {
            updateEvent({
                variables: {
                    model: {
                        id,
                        isAssigneeReplacementReason: !isAssigneeReplacementReason,
                    },
                },
            });
        }}/>
    </Flexbox>);
};
export default EditEventIsAssigneeReplacementReason;
